<template>
  <div class="Page Selfie">

  </div>
</template>

<script>
import Page from '@/core/mixins/Page'

export default {
  name: 'Selfie',
  mixins: [Page],
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Selfie
  height 100%
  overflow hidden


</style>
